// extracted by mini-css-extract-plugin
module.exports = {"playerDark":"Music_playerDark__CTIjN","playerLight":"Music_playerLight__2Pwe3","musicItem":"Music_musicItem__1uetX"};